import { Component } from '@angular/core';
import { BaseMenuItemComponent } from '../../base/base-menu-item.component';

@Component({
  selector: 'lbt-menu-item',
  standalone: false,
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss',
})
export class MenuItemComponent extends BaseMenuItemComponent{
}
